import { Dialog, DialogContent, DialogTitle, Tab, Tabs, Box,Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import  TabsMigracion  from "./Tabs/TabsMigracion";
import { MENU_HISTORIAL_CONSUMO_EMP } from "../../../utils/constants";
import { types } from "../../../types/types";
import PropTypes from "prop-types";
import TabsEmpadronamiento from "./Tabs/TabsEmpadronamiento";
import TabsMedicacion from "./Tabs/TabsMedicacion";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ModalHistorialConsumosEmp = (props) => {
    const dispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState(MENU_HISTORIAL_CONSUMO_EMP.EMPADRONAMIENTO);
    
    useEffect(() => {
      dispatch({
        type: types.empadronamientoGetSolicitudesHistorialError,
      });
    }, [dispatch]);
    
    return (
      <Dialog fullWidth maxWidth="xl" open={props.open} onClose={props.onClose}>
        <DialogTitle>
          Historial Consumos&nbsp;
        </DialogTitle>
        <DialogContent>
          <Tabs
            value={selectedTab}
            onChange={(event, newValue) => setSelectedTab(newValue)}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              value={MENU_HISTORIAL_CONSUMO_EMP.EMPADRONAMIENTO}
              label="Empadronamiento"
              {...a11yProps(MENU_HISTORIAL_CONSUMO_EMP.EMPADRONAMIENTO)}
            />
            <Tab
              value={MENU_HISTORIAL_CONSUMO_EMP.MEDICACION}
              label="Medicación"
              {...a11yProps(MENU_HISTORIAL_CONSUMO_EMP.MEDICACION)}
            />
            <Tab
              value={MENU_HISTORIAL_CONSUMO_EMP.MIGRACION}
              label="Migración"
              {...a11yProps(MENU_HISTORIAL_CONSUMO_EMP.MIGRACION)}
            />
          </Tabs>
          <TabPanel
            value={selectedTab}
            index={MENU_HISTORIAL_CONSUMO_EMP.EMPADRONAMIENTO}
          >
            <TabsEmpadronamiento afiliado={props?.afiliado} />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={MENU_HISTORIAL_CONSUMO_EMP.MEDICACION}
          >
            <TabsMedicacion afiliado={props?.afiliado} />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={MENU_HISTORIAL_CONSUMO_EMP.MIGRACION}
          >
            <TabsMigracion afiliado={props?.afiliado} />
          </TabPanel>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default ModalHistorialConsumosEmp;
  